// Components
import { Fragment } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyMobileCTA from './components/StickyMobileCTA';
import LanguageSync from './components/LanguageSync';

import HomePage from './pages/HomePage';
import BlogPostPage from './pages/BlogPostPage';

import { PREFIXED_LANGUAGES } from './utils/language';

import './App.css';

function App() {
    return (
        <div className="app">
            <LanguageSync />
            <Header />

            <main className="main">
                <Routes>
                    {/* Узбекская версия — на корневых URL, без префикса */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/blog/posts/:slug" element={<BlogPostPage />} />

                    {/* '/uz/...' нормализуется в LanguageSync, здесь — только рендер */}
                    <Route path="/uz" element={<HomePage />} />
                    <Route path="/uz/blog/posts/:slug" element={<BlogPostPage />} />

                    {PREFIXED_LANGUAGES.map((language) => (
                        <Fragment key={language}>
                            <Route path={`/${language}`} element={<HomePage />} />
                            <Route
                                path={`/${language}/blog/posts/:slug`}
                                element={<BlogPostPage />}
                            />
                        </Fragment>
                    ))}

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>

            <Footer />
            <StickyMobileCTA />
        </div>
    );
}

export default App;
